$(document).ready(function() {
    console.log('productDiscount初始化');
    // 倒计时
    let getTime = new Date().getTime() //获取中国时间戳\n     
    getTime = getTime - 15 * 3600 * 1000
    getTime = new Date(getTime);
    console.log('getTime', getTime)

    function timerFlash(intDiff) {
        var day = 0,
            hour = 0,
            minute = 0,
            second = 0; //时间默认值
        intDiff = intDiff - 0;
        if (intDiff > 0) {
            hour = Math.floor(intDiff / 1000 / 60 / 60);
            minute = Math.floor(intDiff / 1000 / 60 % 60);
            second = Math.floor(intDiff / 1000 % 60);
        }
        if (hour < 10) {
            $('.anniversary-time_valH').text('0' + hour);
        } else {
            $('.anniversary-time_valH').text(hour);
        }
        if (minute < 10) {
            $('.anniversary-time_valM').text('0' + minute);
        } else {
            $('.anniversary-time_valM').text(minute);
        }
        if (second < 10) {
            $('.anniversary-time_valS').text('0' + second);
        } else {
            $('.anniversary-time_valS').text(second);
        }
    }
    /* getLocalTime:时区换算*/
    window.getLocalTime = function(i) {
        //参数i为时区值数字，比如北京为东八区则输进8,西5输入-5
        if (typeof i !== 'number') return;
        var d = new Date();
        //得到1970年一月一日到现在的秒数
        var len = d.getTime();
        //本地时间与GMT时间的时间偏移差
        // var offset = d.getTimezoneOffset() * 60000;
        //得到现在的格林尼治时间
        // var utcTime = len + offset;
        // console.log('格林尼治时间:', len);
        return new Date(len * i);
    }
    var newdate = getLocalTime(1);
    var startFlag = true;
    var endFlag = true;
    var s_year = newdate.getFullYear();
    console.log(s_year);
    var s_month = newdate.getMonth() + 1;
    console.log(s_month);
    var s_day = newdate.getDate();
    console.log(s_day);
    var s_time = newdate.toLocaleTimeString();
    console.log(s_time);
    var brandDay_start_time = s_year + "/" + s_month + "/" + s_day + " " + s_time;
    var brandDay_end_time = s_year + "/" + s_month + "/" + s_day + " " + "23:59:59";
    var startTime = new Date(brandDay_start_time);
    var endTimeAnni = new Date(brandDay_end_time);
    var endAllTime = endTimeAnni.getTime() - newdate;
    var limistTime = setInterval(function() {
        if (endAllTime > 0) {
            endAllTime = endAllTime - 1000;
            timerFlash(endAllTime)
        } else {
            $('.anniversary-time_info').text('Has Ended:');
            $('.anniversary-time_valH,.anniversary-time_valM,.anniversary-time_valS').text('00');
            // 到达时间后 商品置灰
            // $('.flash-product_item').each(function() {
            //     $(this).find('.flash-product_buybtn').addClass('disabled').find('.flash-product_buyTips').text('sold out');
            //     $(this).find('.flash-product_img').addClass('flash-product_img--sold');
            // });
            clearInterval(limistTime);
            // 
        }
    }, 1000);
});